import { Component, OnInit} from '@angular/core'
import { EAppEnrollmentComponent } from './e-app-enrollment.component'

@Component({
    selector: 'EAppEnrollmentReadonly',
    templateUrl: 'e-app-enrollment.component.html'
})

export class EAppEnrollmentReadonlyComponent extends EAppEnrollmentComponent implements OnInit {
    ngOnInit() {
        super.ngOnInit()
        this.disabled = true
   }
}